define('modules/editor/models/property_groups/form_input_format',['require','exports','module','./base','lib/util'],function(require, exports, module) {
  "use strict";
  var BasePropertyGroup = require("./base"),
      util = require("lib/util");

  /**
   * Form Input fields Format property group model
   */
  module.exports = BasePropertyGroup.extend({
    name: "form:inputFormat",
    properties: [
      "fontFamily",
      "backgroundColor",
      "height",
      "marginBottom",
      "fontSize",
      "borderRadius",
      "borderStyle",
      "borderWidth",
      "borderColor"
    ],
    generateStyles: function($el, id) {
      return [
        {
          //select input.text and select
          selector: "#" + id + " input[type=text], #" + id + " input[type=password], #" + id + " input[type=email], #" + id + " select",
          rules: {
            "font-family": this.get("fontFamily"),
            "background-color": this.get("backgroundColor"),
            "font-size": this.get("fontSize") + "px",
            "border-width": (this.get("borderWidth") || 0) + "px",
            "border-radius": (this.get("borderRadius") || 0) + "px",
            "border-color": this.get("borderColor"),
            "height": this.get("height") + "px",
            "margin-bottom": this.get("marginBottom") + "px"
          }
        },
        {
          selector: "#" + id + " textarea",
          rules: {
            "font-family": this.get("fontFamily"),
            "background-color": this.get("backgroundColor"),
            "font-size": this.get("fontSize") + "px",
            "border-width": this.get("borderWidth") + "px",
            "border-radius": this.get("borderRadius") + "px",
            "border-color": this.get("borderColor"),
            "margin-bottom": this.get("marginBottom") + "px"
          }
        }
      ];
    },
    validators: {
      "height": function(attrs){
        var value = parseInt(attrs.height);
        return this.isInteger(attrs.height) && this.isNumber(value) && this.isInRange(value, 10, 60);
      },
      "marginBottom": function(attrs){
        var value = parseInt(attrs.marginBottom);
        return this.isInteger(attrs.marginBottom) && this.isNumber(value) && this.isInRange(value, 1, 60);
      },
      "fontSize": function(attrs){
        var value = parseInt(attrs.fontSize);
        return this.isInteger(attrs.fontSize) && this.isNumber(value) && this.isInRange(value, 10, 60);
      },
      "borderRadius": function(attrs){
        var value = parseInt(attrs.borderRadius);
        return this.isInteger(attrs.fontSize) && this.isNumber(value) && this.isInRange(value, 0, 20);
      },
      borderWidth: function(attrs){
        var value = parseInt(attrs.borderWidth);
        //optional
        return (attrs.borderWidth === "") || (this.isInteger(attrs.borderWidth) && this.isNumber(value) && this.isInRange(value, 0, 20));
      }
    },

    //override to do nothing
    // applyStyles: function($el){
    //   var inputControls = $el.find("input[type='text'], textarea, select");
    //   _.each(this.properties, function(name){
    //     if(name === "fontSize" || name === "borderWidth" || name === "borderRadius" || name === "marginBottom"){
    //       inputControls.css(name, this.get(name) + "px");
    //     }
    //     else {
    //       inputControls.css(name, this.get(name));
    //     }
    //   },this);
    //   //remove height from textarea
    //   $el.find("textarea").css("height", "");

    // }
  });

  //common validation functions
  function isNumber(value){
    if(!_.isNumber(value) || _.isNaN(value)){
      return false;
    }
    return true;
  }

  function isInRange(value, bottomLimit, topLimit){
    if(value <= topLimit && value >= bottomLimit){
      return true;
    }
    return false;
  }

  //util.mixin(module.exports, require("behaviours/apply_css_properties"));

});

